import React, { useCallback, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, IconEnum, TextInput, Title } from '@investoro/core';
import styled from 'styled-components';
import { userApiRequests } from 'utils/api-requests/user';
import { validatePasswordFields } from 'utils/validatePasswordOptions';

import InputContainer from 'components/common/InputContainer';
import { activeNotification } from 'components/functions/activeNotification';

const Container = styled.div`
    display: flex;
    width: 100%;
    min-height: 100vh;
    height: auto;

    align-items: center;
    justify-content: center;
`;

const Form = styled.form`
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
    padding: 25px;
    border-radius: 10px;
    gap: 30px;
    background: var(--color-white);
    margin: 0 10px;
    width: 100%;
    max-width: 500px;
`;

const ButtonContainer = styled.div`
    width: fit-content;
    align-self: flex-end;
`;

const ResetPasswordPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const [passwordFields, setPasswordFields] = useState({
        password: '',
        confirmPassword: ''
    });

    const [triggerValidation, setTriggerValidation] = useState(false);

    const handlePasswordChange = useCallback((field: string, value: string) => {
        setPasswordFields((prev) => ({
            ...prev,
            [field]: value
        }));
    }, []);

    const errors = validatePasswordFields('', passwordFields.password, passwordFields.confirmPassword, {
        requireOldPassword: false
    });

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setTriggerValidation(true);

        const hasErrors = Object.values(errors).some((err) => err);

        if (hasErrors) {
            activeNotification('Hasło', 'Wypełnij poprawnie wszystkie pola', 'warning');

            return;
        }

        if (!token) {
            activeNotification('Błąd', 'Brak tokena resetującego. Spróbuj ponownie.', 'danger');

            return;
        }

        const success = await userApiRequests.resetPasswordWithLink({
            password: passwordFields.password,
            confirmPassword: passwordFields.confirmPassword,
            token
        });

        if (success) {
            navigate('/');
        }
    };

    return (
        <Container>
            <Form onSubmit={handleSubmit}>
                <Title>Ustaw nowe hasło</Title>

                <InputContainer title="Nowe hasło" icon={IconEnum.BLOCKED} required>
                    <TextInput
                        type="password"
                        value={passwordFields.password}
                        onChange={(e) => handlePasswordChange('password', e.target.value)}
                        placeholder="Min. 8 znaków, duża litera i cyfra"
                        required
                        errorMessage={errors.password}
                        inputValidation={() => !!errors.password}
                        triggerValidation={triggerValidation}
                    />
                </InputContainer>

                <InputContainer title="Potwierdź hasło" icon={IconEnum.BLOCKED} required>
                    <TextInput
                        type="password"
                        value={passwordFields.confirmPassword}
                        onChange={(e) => handlePasswordChange('confirmPassword', e.target.value)}
                        placeholder="Potwierdź hasło"
                        required
                        errorMessage={errors.confirmPassword}
                        inputValidation={() => !!errors.confirmPassword}
                        triggerValidation={triggerValidation}
                    />
                </InputContainer>

                <ButtonContainer>
                    <Button >Zmień hasło</Button>
                </ButtonContainer>
            </Form>
        </Container>
    );
};

export default ResetPasswordPage;
